/**
 *
 * @param array - The array to be randomized
 * @returns A shallow-copy array with items randomized from the original
 */
export function randomizeArray<T>(array: T[]): T[] {
  return [...array].sort(() => Math.random() - 0.5);
}
